import React from 'react';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@mui/material';

import ErrorTooltip from '../error-tooltip/ErrorTooltip';

import scss from './DataBlock.module.scss';

function DataBlock({ r1, r2, certainty, error, isLoading }) {
  const { t } = useTranslation('genie');

  const formattedData = [
    {
      label: 'R1',
      value: (r1 ?? '-') + '%',
      color: scss.blue,
    },
    {
      label: 'R2',
      value: (r2 ?? '-') + '%',
      color: scss.green,
    },
    {
      label: t('certainty'),
      value: (certainty ?? '-') + '%',
      color: scss.primary,
    },
  ];

  return (
    <div className={scss.wrapper}>
      {formattedData.map(({ label, value, color }) => (
        <div key={label} className={scss.item}>
          <span>{label}</span>
          {isLoading && typeof certainty === 'undefined' ? (
            <Skeleton
              variant='text'
              sx={{ borderRadius: '2px', bgcolor: '#9ba0a650', fontSize: '14px', width: '25px' }}
            />
          ) : (
            <div className={color}>{value}</div>
          )}
        </div>
      ))}

      <ErrorTooltip error={error} />
    </div>
  );
}

export default DataBlock;
